import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect } from "react";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { OptionalConsentsResource } from "@ploy-lib/rest-resources";
import { useResource } from "@rest-hooks/core";
import { useDispatch } from "@ploy-lib/calculation";
import { Section } from "..";
import { ErrorHandler } from "@ploy-lib/core";
import { ErrorPageContent } from "@ploy-ui/core";
addRegisteredSectionLayout({
    name: "OptionalConsentsSection",
    displayName: "OptionalConsentsSection",
    settings: {}
});
const OptionalConsentsSectionInternal = memo(props => {
    const dispatch = useDispatch();
    var optionalConsents = useResource(OptionalConsentsResource.list(), {});
    useEffect(() => {
        dispatch({
            type: "field_patch",
            payload: {
                patches: [
                    {
                        fieldName: `consents`,
                        namespace: "AdditionalSubmitValues",
                        initialValue: optionalConsents.reduce((obj, c) => ({ ...obj, [c.id]: false }), {})
                    }
                ]
            }
        });
    }, [dispatch, optionalConsents]);
    var fields = optionalConsents.map(c => ({
        formTemplateFieldId: "consents." + c.id,
        namespace: "AdditionalSubmitValues",
        name: "consents." + c.id,
        renderAs: "CheckboxWithLabelField",
        label: c.description,
        alwaysVisible: true
    }));
    return (_jsx(Section, { ...props, formTemplateSectionId: "consents", fields: fields }));
});
const OptionalConsentsSection = (props) => (_jsx(ErrorHandler, { fallback: e => (_jsx(ErrorPageContent, { className: props.className, onClick: props.onClick, header: _jsxs("span", { children: [OptionalConsentsSection.displayName, " failed to render."] }) })), children: _jsx(OptionalConsentsSectionInternal, { ...props }) }));
OptionalConsentsSection.displayName = "OptionalConsentsSection";
export { OptionalConsentsSection };
//# sourceMappingURL=OptionalConsentsSection.js.map